import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { connect } from 'react-redux';
import { HorizontalBar } from 'react-chartjs-2';
import { makeStyles, Typography, Button } from '@material-ui/core';

import OpenMoc from 'src/features/openPrc';

import Tab from 'src/components/tab';
import ChartLegend from 'src/components/chartLegend';
import ChartWrapper from 'src/components/chartWrapper';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from 'src/components/table';
import TooltipedText from 'src/components/tooltipedText';

import { coloredDatasets } from 'src/helpers/chartJsHelpers';

import { setTabExpend } from './slice';

const legend = ['Total lead volume', 'Connected', 'Tagged'];

const data = coloredDatasets('bar', {
  labels: ['1st Attempt', '2nd Attempt', '3rd Attempt', '4th Attempt', '5th Attempt', '6th Attempt'],
  datasets: [
    {
      label: 'Total lead volume',
      data: [12, 19, 3, 5, 3, 5],
      borderWidth: 0,
    },
    {
      label: 'Connected',
      data: [12, 19, 3, 5, 3, 5],
      borderWidth: 0,
    },
    {
      label: 'Tagged',
      data: [12, 19, 3, 5, 3, 5],
      borderWidth: 0,
    },
  ],
});

const options = {
  maintainAspectRatio: false,
  cornerRadius: 10,
  fullCornerRadius: false,
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          stepSize: 5,
          padding: 20,
        },
        gridLines: {
          display: false,
        },
        barPercentage: 0.6,
        categoryPercentage: 0.6,
        afterFit: scaleInstance => {
          // eslint-disable-next-line no-param-reassign
          scaleInstance.width = 120; // sets the width to 120px
        },
      },
    ],
    xAxes: [
      {
        ticks: {
          beginAtZero: true,
          display: false,
          padding: 20,
        },
        gridLines: {
          display: false,
        },
      },
    ],
  },
  legend: {
    display: false,
  },
  tooltips: {
    mode: 'nearest',
  },
};

const useStyles = makeStyles(theme => ({
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
  },
  table: {
    minWidth: 800,
  },
  openMocWrapper: {
    // marginTop: theme.spacing(4),
  },
}));

const LeadResults = props => {
  const { isTabExpended } = props;
  const classes = useStyles();

  const prismicContent = useStaticQuery(graphql`
    query {
      allPrismicOverview {
        edges {
          node {
            data {
              title4 {
                html
                text
                raw
              }
              tooltip4a {
                html
                text
                raw
              }
              tooltip4b {
                html
                text
                raw
              }
            }
          }
        }
      }
    }
  `);

  const prismicData = prismicContent.allPrismicOverview.edges[0].node.data;

  const handelExpand = () => {
    props.setTabExpend(!isTabExpended);
  };

  return (
    <>
      <Tab title={prismicData.title4.text} drag onClick={handelExpand} expanded={isTabExpended}>
        <ChartLegend legend={legend} maxWidth={500} />
        <ChartWrapper>
          <HorizontalBar data={data} options={options} height={400} />
        </ChartWrapper>
        <TableContainer>
          <Table className={classes.table} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>1st Attempt</TableCell>
                <TableCell>2nd Attempt</TableCell>
                <TableCell>3rd Attempt</TableCell>
                <TableCell>4th Attempt</TableCell>
                <TableCell>5th Attempt</TableCell>
                <TableCell>6th Attempt</TableCell>
                <TableCell>Total</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell component="th" scope="row">
                  <Typography variant="body2" align="right">
                    Press 2
                  </Typography>
                </TableCell>
                <TableCell>70%</TableCell>
                <TableCell>70%</TableCell>
                <TableCell>70%</TableCell>
                <TableCell>70%</TableCell>
                <TableCell>70%</TableCell>
                <TableCell>70%</TableCell>
                <TableCell />
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  <TooltipedText tooltipText={prismicData.tooltip4a.text} position="flex-end">
                    <Typography variant="body2">Connections</Typography>
                  </TooltipedText>
                </TableCell>
                <TableCell>
                  70%
                  <Typography variant="h6" style={{ opacity: 0.5 }}>
                    20
                  </Typography>
                </TableCell>
                <TableCell>
                  70%
                  <Typography variant="h6" style={{ opacity: 0.5 }}>
                    20
                  </Typography>
                </TableCell>
                <TableCell>
                  70%
                  <Typography variant="h6" style={{ opacity: 0.5 }}>
                    20
                  </Typography>
                </TableCell>
                <TableCell>
                  70%
                  <Typography variant="h6" style={{ opacity: 0.5 }}>
                    20
                  </Typography>
                </TableCell>
                <TableCell>
                  70%
                  <Typography variant="h6" style={{ opacity: 0.5 }}>
                    20
                  </Typography>
                </TableCell>
                <TableCell>
                  70%
                  <Typography variant="h6" style={{ opacity: 0.5 }}>
                    20
                  </Typography>
                </TableCell>
                <TableCell />
              </TableRow>
              <TableRow>
                <TableCell component="th" scope="row">
                  <TooltipedText tooltipText={prismicData.tooltip4b.text} position="flex-end">
                    <Typography variant="body2" align="right">
                      Missed Opportunities
                    </Typography>
                  </TooltipedText>
                </TableCell>
                <TableCell>10</TableCell>
                <TableCell>10</TableCell>
                <TableCell>10</TableCell>
                <TableCell>10</TableCell>
                <TableCell>10</TableCell>
                <TableCell>10</TableCell>
                <TableCell>10</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Tab>
      <div className={classes.openMocWrapper}>
        <OpenMoc />
      </div>
    </>
  );
};

const mapStateToProps = ({ me }) => {
  const { overview } = me;
  const { leadResults } = overview;
  return { ...leadResults };
};

const mapDispatchToProps = { setTabExpend };

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(LeadResults));
